import React from 'react';import { OrbitControls } from "@react-three/drei";

const Controls = ({ pivot }) => 
{
  return (
    <OrbitControls
      enableZoom={true} // Permite hacer zoom
      enablePan={false} // Evita el desplazamiento lateral
      minPolarAngle={Math.PI / 6} // Limita la rotación hacia abajo
      maxPolarAngle={Math.PI / 2} // Evita que la cámara rote completamente
      target={[pivot.x, pivot.y, pivot.z]} // Ahora el pivot de rotación es el centro del grid
    />
  );
};

export default Controls;
